<community-verify-email-banner
  *ngIf="verifyEmailNotification$ | async as notification"
  [notification]="notification"
></community-verify-email-banner>

<trp-banner
  *ngIf="emailVerifiedNotification$ | async as notification"
  (dismiss)="notificationFacade.dismissNotification(notification.id)"
  [autoDismiss]="10000"
>
  {{ 'banner.emailVerified.text' | translate }}

  <a
    trpBannerAction
    mat-stroked-button
    (click)="notificationFacade.dismissNotification(notification.id)"
    [routerLink]="['/recommendation/access']"
  >
    {{ 'banner.emailVerified.requestAccessToCommunities' | translate }}
  </a>
</trp-banner>

<trp-banner
  *ngIf="communityUpdates.approvedAggregate$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [bannerType]="'success'"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.communityUpdate.approved.one'
      | translate
        : { communityName: aggregate.notifications[0].content.communityName }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.communityUpdate.approved.plural'
      | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
  <button
    trpBannerAction
    mat-stroked-button
    [routerLink]="['/recommendation']"
    (click)="aggregate.dismiss()"
  >
    {{ 'banner.communityUpdate.approved.goToProgramCoach' | translate }}
  </button>
</trp-banner>

<trp-banner
  *ngIf="communityUpdates.rejectedAggregate$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [bannerType]="'error'"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.communityUpdate.rejected.one'
      | translate
        : { communityName: aggregate.notifications[0].content.communityName }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.communityUpdate.rejected.plural'
      | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
  <a
    trpBannerAction
    mat-stroked-button
    [attr.href]="contactHref$ | async"
    >{{ 'banner.communityUpdate.rejected.contactUs' | translate }}</a
  >
</trp-banner>

<trp-banner
  *ngIf="communityUpdates.submittedAggregate$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [bannerType]="'info'"
  [autoDismiss]="10000"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.communityUpdate.submitted.one'
      | translate
        : { communityName: aggregate.notifications[0].content.communityName }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.communityUpdate.submitted.plural'
      | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
</trp-banner>

<trp-banner
  *ngIf="approvedAggregate$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [autoDismiss]="10000"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.approved.one'
      | translate
        : { communityName: aggregate.notifications[0].content.community.name }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.approved.plural' | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
  <a
    trpBannerAction
    mat-stroked-button
    [routerLink]="['/recommendation']"
    (click)="aggregate.dismiss()"
  >
    {{ 'banner.approved.goToProgramCoach' | translate }}
  </a>
</trp-banner>

<trp-banner
  *ngIf="rejectedAggregate$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [bannerType]="'error'"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.rejected.one'
      | translate
        : { communityName: aggregate.notifications[0].content.community.name }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.rejected.plural' | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
</trp-banner>

<trp-banner
  *ngIf="createdAggregate$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [bannerType]="'warning'"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.created.one'
      | translate
        : { communityName: aggregate.notifications[0].content.community.name }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.created.plural' | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
</trp-banner>

<ng-container
  *ngIf="notificationFacade.simpleNotification$ | async as notification"
>
  <trp-banner
    *ngIf="notification && notification.dismiss === false"
    [autoDismiss]="3000"
    [bannerType]="notification.type"
    (dismiss)="notificationFacade.dismissSimpleNotification()"
  >
    {{ notification.message | translate }}
  </trp-banner>
</ng-container>

<trp-banner
  *ngIf="programVerifications.verifiedAggregates$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [autoDismiss]="10000"
  [bannerType]="'success'"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.programVerification.verified.one'
      | translate
        : { communityName: aggregate.notifications[0].content.communityName }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.programVerification.verified.plural'
      | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
</trp-banner>

<trp-banner
  *ngIf="programVerifications.verificationExpiredAggregates$ | async as aggregate"
  (dismiss)="aggregate.dismiss()"
  [bannerType]="'warning'"
>
  <ng-container *ngIf="aggregate.count === 1">{{
    'banner.programVerification.verificationExpired.one'
      | translate
        : { communityName: aggregate.notifications[0].content.communityName }
  }}</ng-container>
  <ng-container *ngIf="aggregate.count > 1">{{
    'banner.programVerification.verificationExpired.plural'
      | translate : { numberOfCommunities: aggregate.count }
  }}</ng-container>
  <a
    trpBannerAction
    mat-stroked-button
    [routerLink]="['/recommendation']"
    (click)="aggregate.dismiss()"
  >
    {{
      'banner.programVerification.verificationExpired.goToCommunities'
        | translate
    }}
  </a>
</trp-banner>